// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__MIdrZ","notice":"styles_notice__b0oMq","orientation":"styles_orientation__RZVpV"};